import { simpleCopy } from '@/utils/deepCopy';

/**
 * 演算子の定義
 */
export type Operator = '+' | '-' | '*' | '/' | '(' | ')';

const _OPERATORS: readonly Operator[] = ['+', '-', '*', '/', '(', ')'];

/**
 * 演算子の取得
 * @returns Operator[]
 */
export const getOperators = (): readonly Operator[] => {
  return simpleCopy(_OPERATORS);
};

/**
 * 演算子の表示名を取得する
 * @param operator - 演算子
 */
export const getDisplayOperator = (operator: Operator): string => {
  switch (operator) {
    case '+':
      return '+';
    case '-':
      return '-';
    case '*':
      return '✖️';
    case '/':
      return '÷';
    case '(':
      return '(';
    case ')':
      return ')';
  }
};
